/**
 * API统一入口
 */
import * as auth from './auth'
import * as utils from './utils'
import * as user from './user'
import * as forum from './forum'
import * as payment from './payment'

export default {
  auth,
  utils,
  user,
  forum,
  payment
}

// 也可以单独导出
export { auth, utils, user, forum, payment }
